import { render, staticRenderFns } from "./preschooldetails.vue?vue&type=template&id=46a86d15&scoped=true"
import script from "./preschooldetails.vue?vue&type=script&lang=js"
export * from "./preschooldetails.vue?vue&type=script&lang=js"
import style0 from "./preschooldetails.vue?vue&type=style&index=0&id=46a86d15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a86d15",
  null
  
)

export default component.exports